export default __webpack_public_path__ + "static/media/poster-setting.40170344.png";